module.exports = __webpack_public_path__ + "static/media/gb-sct.bf86aba7.svg";